import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { NavController, AlertController, ViewController, NavParams, LoadingController } from 'ionic-angular';
import { LotteryService } from "../../services/lottery.services";
import { AppConfigService } from "../../services/appConfig.service";
import { LotteryTabsPage } from "../lotteryTabPanel/lotteryTabPanel";
import { HomePage } from "../home/home";
import { SixMarkService } from "../../services/sixmark.services";
import * as common from '../../directives/common';
import { TranslateService } from 'ng2-translate';

@Component({
    templateUrl: 'recordList.html',
    selector: 'record-list-page',
    providers: [DatePipe]
})
export class RecordListPage implements OnInit {
    //判断是否实例化
    static hasInit: boolean = false;
    private recordList: any = [];
    // private infiniteScrollBoolean: boolean = true;
    private lotteryName: string;
    private lotteryId: number;

    // arrMMCGameID = [100, 101, 102, 103, 104, 80, 91, 93,400,401,402];
    arrMMCGameID = [100, 101, 102, 103, 104, 80 , 91, 93, 300,301,302,303,304,305, 400,401,402];
    flagMMCGame: boolean = false;

    private winNumber = {
        nums: [],
        issue: '',
        type: 0 // 0: dau-duoi, 1: duoi-dau
    };

    public isTaiXiu: boolean = false;
    public isXocDia: boolean = false;
    public isBauCua: boolean = false;
    public recordListTaiXiu: any = [];
    public recordListXocDia: any = [];
    public recordListBauCua: any = [];

    constructor(public navParams: NavParams, private nav: NavController, private alertCtrl: AlertController,
        private lotteryService: LotteryService, public viewCtrl: ViewController,
        private sixMarkService: SixMarkService, private loadingCtrl: LoadingController,
        private datePIPE: DatePipe, private translate: TranslateService) {
        this.lotteryId = navParams.data["lotteryId"];
        if (common.checkGameTaiXiu(this.lotteryId)) {
            this.isTaiXiu = true;
        }
        if (common.checkGameXocDia(this.lotteryId)) {
            this.isXocDia = true;
        }
        if (this.lotteryId === 93) { // is bau cua 1 phut
            this.isBauCua= true;
        }
        this.lotteryName = navParams.data["lotteryName"];
        RecordListPage.hasInit = true;
    }

    goDetail() {
        let rootNav = this.nav;
        if (LotteryTabsPage.hasInit) {
            rootNav.pop();
        } else {
            let lottery: any = HomePage.lotteryIDList[this.lotteryId];
            rootNav.push(LotteryTabsPage, {
                lotteryName: lottery.name,
                lotteryId: this.lotteryId,
                balance: lottery.balance,
                title: lottery.description,
                titleGame: lottery.title
            });
        }
    }

    doRefresh(refresher) {
        if (this.lotteryId === 81 || this.lotteryId === 82) {
            this.getFirstDataSM(refresher);
        } else {
            this.getFirstData(refresher);
        }
    }

    /**
     * getWinOpenNumberSM()
     * get win open number of sixmark and dice
     */
    getFirstDataSM(refresher: any = null) {
        let dataParams = {
            lotteryid: this.lotteryId,
            num: 50
        };
        this.sixMarkService.lotteryWinOpenNumber(dataParams, this.alertCtrl).then(response => {
            if (response["status"] = "success") {
                this.recordList = response["data"];
                this.recordList.map(item => {
                    item["winnumber"] = this.smWinNumberToArray(item["winnumber"]);
                    return item;
                });
                if (refresher) {
                    refresher.complete();
                    // this.infiniteScrollBoolean = true;
                }
            }
        });
    }

    /**
     * convert win number of sm to array
     */
    smWinNumberToArray(data) {
        let numbers = [];
        // winnumber exp: "12|43|21|9|2|10&7"
        // special number -> 7
        // numbers array 1->6 => 12, 43, 21, 9, 2, 10
        let types = data.split('&');

        if (types.length === 2) {
            let specialNumber = Number.parseInt(types[1]);
            let normalNumbers = types[0].split('|');

            numbers.push(specialNumber);
            normalNumbers.forEach(number => {
                numbers.push(Number.parseInt(number));
            });
        }
        return numbers;
    }

    /**
     * @param winNumber: null || "1|5|2" = 1giay || "152" = 1phut
     * @returns {any}
     */
    convertWinNumber(winNumber) {
        let strWin = winNumber || null;
        if (strWin && this.lotteryId === 92) {
            strWin = winNumber.split('|');
        }else if (strWin && this.lotteryId === 93) {
            strWin = winNumber.split(',');
        }
        return strWin;
    };

    getFirstData(refresher: any = null) {
        let dataParams = { id: this.lotteryId };

        if (this.arrMMCGameID.indexOf(dataParams["id"]) > -1) {
            this.flagMMCGame = true;
        }
        this.lotteryService.lotteryWinOpenNumberList(dataParams, this).then(data => {
            if (!data["msg"]) {
                this.recordList = data["reslist"];
                if (!this.isTaiXiu && !this.isXocDia && !this.isBauCua) {
                    this.recordList.map(item => {
                        item["winnumber"] = item["winnumber"].split(',');
                        item["winnumberHtml"] = common.tblResultAll(item["winnumber"], dataParams["id"], this.translate);
                        if (!this.flagMMCGame) {
                            item["issue"] = this.datePIPE.transform(item["issue"], 'dd/MM/yyyy');
                        }
                        return item;
                    });
                } else if (this.isXocDia) {
                    this.recordList.map(item => {
                        let objTemp = {};
                        objTemp['issue'] = item.issue;
                        objTemp['winnumberarr'] = item.winnumberarr;
                        this.recordListXocDia.push(objTemp);
                    });
                } else if (this.isBauCua) {
                    this.recordList.map(item => {
                        let objTemp = {};
                        objTemp['issue'] = item.issue;
                        const winnumberIcon =  this.convertWinNumber(item.winnumber).map(itemWinNum => {
                            if (Number(itemWinNum) === 1) {
                                itemWinNum = 'nai';
                            }else if (Number(itemWinNum) === 2) {
                                itemWinNum = 'cua';
                            }else if (Number(itemWinNum) === 3) {
                                itemWinNum = 'ga';
                            }else if (Number(itemWinNum) === 4) {
                                itemWinNum = 'ca';
                            }else if (Number(itemWinNum) === 5) {
                                itemWinNum = 'bau';
                            }else if (Number(itemWinNum) === 6) {
                                itemWinNum = 'tom';
                            }
                            return itemWinNum
                        });
                        objTemp['winnumberarr'] = winnumberIcon;
                        this.recordListBauCua.push(objTemp);
                    });
                } else {
                    this.recordList.map(item => {
                        let objTemp = {};
                        objTemp['issue'] = item.issue;
                        objTemp['detail'] = item.winnumber.split(',').sort();
                        let winItem = objTemp['detail'];
                        let totalDice = Number(winItem[0]) + Number(winItem[1]) + Number(winItem[2]);
                        Number(winItem[0]) == Number(winItem[1]) && Number(winItem[0]) == Number(winItem[2]) ? (objTemp['daxiaoCls'] = "sign-baozi", objTemp['daxiaoText'] = "-", objTemp['danshuangCls'] = "sign-baozi", objTemp['danshuangText'] = "-") : (totalDice > 10 ? (objTemp['daxiaoCls'] = "sign-big", objTemp['daxiaoText'] = "T") : (objTemp['daxiaoCls'] = "sign-small", objTemp['daxiaoText'] = "X"), totalDice % 2 == 1 ? (objTemp['danshuangCls'] = "sign-odd", objTemp['danshuangText'] = "L") : (objTemp['danshuangCls'] = "sign-even", objTemp['danshuangText'] = "C"));
                        this.recordListTaiXiu.push(objTemp);
                    });
                }

                if (refresher) {
                    refresher.complete();
                }
            }
        });
    }


    // doInfinite(infiniteScroll) {
    //   let dataParams = {
    //     // lotteryid: LotteryPage.lotteryId
    //   };
    //   infiniteScroll.enable(false);
    //   setTimeout(()=> {
    //     this.lotteryService.lotteryNextRecordBean(dataParams, this.alertCtrl).then(data=> {
    //       if (!data["msg"]) {
    //         data["reslist"].map(item=> {
    //           item["bettime"] = item["bettime"].substr(5, 11);
    //           return item;
    //         });
    //         this.recordList = this.recordList.concat(data["reslist"]);
    //
    //         infiniteScroll.complete();
    //         infiniteScroll.enable(true);
    //       } else {
    //         infiniteScroll.enable(true);
    //         this.infiniteScrollBoolean = false;
    //       }
    //     });
    //   }, 500);
    // }

    ionViewDidLeave() {
        RecordListPage.hasInit = false;
    }

    /*ionViewWillEnter() {
        if (this.lotteryId === 81 || this.lotteryId === 82) {
            this.getFirstDataSM();
        } else {
            this.getFirstData();
        }
    }*/

    ngOnInit() {
        this.getFirstData();
    }

    dauduoi(winnumber, issue) {
        this.winNumber = {
            nums: winnumber,
            issue: issue,
            type: 0
        };
    }
    duoidau(winnumber, issue) {
        this.winNumber = {
            nums: winnumber,
            issue: issue,
            type: 1
        };
    }
}



// WEBPACK FOOTER //
// ./src/pages/recordList/recordList.ts